import { createContext, useContext } from 'react';

export const optionalContextFactory = <T>(initialState?: T) => {
  const Context = createContext<T | undefined>(initialState);

  const useOptionalContextFactory = (): T | undefined => {
    const context = useContext(Context);

    return context;
  };

  return [Context, useOptionalContextFactory] as const;
};
